export default {
  ERROR: 'annSidebarError',
  OPEN_INFO_POPUP: 'openInfoPopup'
};
